import {BufferGeometry,BufferAttribute,Vector3,Box3,Sphere} from 'three';
const rings=12,sides=12,vertices=(rings+1)*(sides+1),indicesPerTube=rings*sides*6;
export function createStickyBridges(capacity=12){
 const geometry=new BufferGeometry(),indices=[];
 for(let tube=0;tube<capacity;tube++)for(let i=0;i<rings;i++)for(let j=0;j<sides;j++){
  const a=tube*vertices+i*(sides+1)+j,b=a+sides+1;indices.push(a,a+1,b,b,a+1,b+1);
 }
 geometry.setAttribute('position',new BufferAttribute(new Float32Array(vertices*capacity*3),3));
 geometry.setIndex(indices);geometry.setDrawRange(0,0);geometry.boundingBox=new Box3();geometry.boundingSphere=new Sphere(new Vector3(),0);return geometry;
}
const axis=new Vector3(),u=new Vector3(),v=new Vector3();
export function updateStickyBridges(geometry,bridges){
 const positions=geometry.attributes.position,capacity=positions.count/vertices;let slot=0;
 for(const bridge of bridges){
  if(bridge.visible===false||bridge.fade===0)continue;
  const {start,end,radius}=bridge;
  const attached=bridge.attached!==false,fade=bridge.fade??1,retract=bridge.retract??0;
  const waist=bridge.waist??radius*(1-.75*(bridge.tension??0));
  const sag=bridge.sag??radius*.22;
  axis.fromArray(end).sub(new Vector3(...start));
  if(axis.lengthSq()<1e-10)continue;
  axis.normalize();u.set(0,Math.abs(axis.y)>.95?0:1,Math.abs(axis.y)>.95?1:0).cross(axis).normalize();v.crossVectors(axis,u).normalize();
  for(let half=0;half<(attached?1:2)&&slot<capacity;half++,slot++){
   for(let i=0;i<=rings;i++){
    const t=i/rings,along=attached?t:half===0?t*.5*(1-retract):1-t*.5*(1-retract);
    const bell=Math.sin(Math.PI*along);
    let r=radius+(waist-radius)*bell*bell;
    if(!attached)r*=Math.sqrt(fade)*Math.sqrt(Math.max(0,1-t**8));
    for(let j=0;j<=sides;j++){
     const angle=j/sides*Math.PI*2*(!attached&&half===1?-1:1),c=Math.cos(angle)*r,s=Math.sin(angle)*r;
     positions.setXYZ(slot*vertices+i*(sides+1)+j,
      start[0]+(end[0]-start[0])*along+u.x*c+v.x*s,
      start[1]+(end[1]-start[1])*along-sag*bell+(u.y*c+v.y*s)*(bridge.verticalScale??1),
      start[2]+(end[2]-start[2])*along+u.z*c+v.z*s);
    }
   }
  }
 }
 // Clear unused slots so bounds never include a previously stretched bridge.
 positions.array.fill(0,slot*vertices*3);positions.needsUpdate=true;
 geometry.setDrawRange(0,slot*indicesPerTube);geometry.computeVertexNormals();
 geometry.boundingBox.makeEmpty();
 for(let i=0;i<slot*vertices;i++)geometry.boundingBox.expandByPoint(axis.fromBufferAttribute(positions,i));
 if(slot)geometry.boundingBox.getBoundingSphere(geometry.boundingSphere);
 else {geometry.boundingSphere.center.set(0,0,0);geometry.boundingSphere.radius=0;}
 return slot>0;
}
